module.exports = __webpack_public_path__ + "img/35.2fe08117.jpeg";